const hideMainProfile = profiles =>
  profiles.filter(profile => profile.name !== 'Principal')

export default hideMainProfile
